type CheckboxProps = {
  className?: string;
  stroke?: string;
};

const Checkbox = ({ className, stroke = "#121212" }: CheckboxProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="1" y="1" width="22" height="22" rx="3" fill="white" />
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      rx="3"
      stroke={stroke}
      strokeWidth="2"
    />
  </svg>
);

export default Checkbox;
